<script>
import utils from '@/utils/common';
import TaskViewParametersPopup from './TaskViewParametersPopup.vue';

export default {
  name: 'TaskViewStatusDispatcher',
  components: { TaskViewParametersPopup },
  props: {
    action: String,
    tasks: Array,
    isOpened: Boolean,
  },
  computed: {
    changedTasksWord() {
      return utils.pluralWord(this.tasks.length, 'задаче', 'задачах', 'задачах');
    },

    options() {
      return {
        new: 'Новая',
        progress: 'В работе',
        paused: 'Пауза',
        review: 'Проверка',
        rework: 'На доработку',
        agreement: 'Согласование',
        closed: 'Завершена',
      };
    },
  },
  methods: {
    async submit(value) {
      const question = `Вы действительно хотите установить новый статус в ${this.changedTasksWord}?`;
      const text = 'Статус установлен';

      if (await this.$confirm(question)) {
        this.$emit('submit', { result: { [this.action]: value }, onSuccess: () => { this.$push({ text }); } });
      }
    },
  },
};
</script>

<template lang="pug">
TaskViewParametersPopup(v-if="isOpened" :options="options" header="Изменить статус" label="Выберите статус" @submit="submit" @close="$emit('close')")
</template>

<style scoped lang="scss">

</style>
